/**
 * Move impulses from seperate store into simulation round
 */

export default {
  applyToVersions: "<=2.2.0",
  type: "before",
  name: "add scheduledImpulses to round",
  migrate(data) {
    if (data?.gameRounds?.items) {
      outerLoop: {
        for (const simulationId in data.gameRounds.items) {
          const rounds = data.gameRounds.items[simulationId] ?? [];
          for (const round of rounds) {
            // if any round has scheduledImpulses, we don't need to convert; abort.
            if (round.scheduledImpulses != null) break outerLoop;

            round.scheduledImpulses = [];
          }
        }
      }
    }
    return data;
  }
};
